<script setup>
import { computed } from 'vue';
import { CONVERSATION_STATUS } from 'shared/constants/messages';

import Icon from 'dashboard/components-next/icon/Icon.vue';
import {
  SEMANTIC_COLOR,
  SEMANTIC_TEXT_CLASSES,
} from 'dashboard/components-next/semanticColors';

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
  showEmpty: {
    type: Boolean,
    default: false,
  },
});

const icons = {
  [CONVERSATION_STATUS.OPEN]: 'i-woot-status-open',
  [CONVERSATION_STATUS.RESOLVED]: 'i-woot-status-resolved',
  [CONVERSATION_STATUS.PENDING]: 'i-woot-status-pending',
  [CONVERSATION_STATUS.SNOOZED]: 'i-woot-status-snoozed',
};

const STATUS_COLOR_MAP = {
  [CONVERSATION_STATUS.OPEN]: SEMANTIC_TEXT_CLASSES[SEMANTIC_COLOR.INFO],
  [CONVERSATION_STATUS.RESOLVED]: SEMANTIC_TEXT_CLASSES[SEMANTIC_COLOR.SUCCESS],
  [CONVERSATION_STATUS.PENDING]: SEMANTIC_TEXT_CLASSES[SEMANTIC_COLOR.WARNING],
  [CONVERSATION_STATUS.SNOOZED]: SEMANTIC_TEXT_CLASSES[SEMANTIC_COLOR.NEUTRAL],
};

const iconName = computed(() => {
  if (props.status && icons[props.status]) {
    return icons[props.status];
  }
  return props.showEmpty ? 'i-woot-status-empty' : '';
});

const statusColor = computed(() => {
  if (props.status && STATUS_COLOR_MAP[props.status]) {
    return STATUS_COLOR_MAP[props.status];
  }
  return props.showEmpty ? SEMANTIC_TEXT_CLASSES[SEMANTIC_COLOR.NEUTRAL] : '';
});
</script>

<template>
  <Icon
    v-tooltip.top="{
      content: status,
      delay: { show: 500, hide: 0 },
    }"
    :icon="iconName"
    :class="statusColor"
    class="size-4 flex-shrink-0"
  />
</template>
